(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_blck_tp_also_available"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tp-also-available')) {
    customElements.define('tp-also-available', class extends HTMLElement {
      connectedCallback() {
        this.section = this.closest('.shopify-section');
        const listing = this.querySelector('recommendations-listing-component');
        const viewport = this.querySelector('.embla__viewport');
        const updateVisibleColors = () => {
          const slide = this.querySelector('.tp-also-slide');
          const container = this.querySelector('.embla__container');
          if (!listing || !viewport || !slide || !container) return;
          const gap = parseFloat(getComputedStyle(container).columnGap) || 0;
          const size = slide.getBoundingClientRect().width;
          if (!size) return;
          const visible = Math.max(1, (viewport.clientWidth + gap) / (size + gap));
          if (Math.abs(visible - Number(listing.dataset.itemsPerRowMobile || 0)) < 0.01) return;
          listing.dataset.itemsPerRowMobile = String(visible);
          this.querySelector('.embla')?.style.setProperty('--slide-per-view-mobile', String(visible));
          listing.emblaApi?.reInit();
        };
        this.resizeObserver = new ResizeObserver(updateVisibleColors);
        if (viewport) this.resizeObserver.observe(viewport);
        updateVisibleColors();
        this.onVariantUpdate = (event) => {
          const data = event.detail?.data;
          if (!data?.html || String(data.productId) !== this.dataset.productId) return;
          const incoming = data.html.getElementById(this.id);
          if (!incoming) return;
          const destinations = new Map([...incoming.querySelectorAll('[data-also-product-id]')]
            .map((link) => [link.dataset.alsoProductId, link.getAttribute('href')]));
          this.querySelectorAll('[data-also-product-id]').forEach((link) => {
            const href = destinations.get(link.dataset.alsoProductId);
            if (href) link.setAttribute('href', href);
          });
        };
        this.section?.addEventListener('variant-picker:update', this.onVariantUpdate);
      }
      disconnectedCallback() {
        this.resizeObserver?.disconnect();
        this.section?.removeEventListener('variant-picker:update', this.onVariantUpdate);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
